import { createFileRoute } from '@tanstack/react-router'
import { AgentCatalogPage } from '../../../modules/agent-workspace'

export const Route = createFileRoute('/_authed/agent-workspace/')({
  component: AgentCatalogPage,
})
